import PropTypes from "prop-types";
import {LoadingScreen} from "../../components";
import { Helmet } from 'react-helmet';
import {
  Container,Grid
} from '@mui/material';
export default function Index(props) {
  const {loading,  children, titulo} = props;
  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>{titulo}</title>
      </Helmet>
      {loading ? <LoadingScreen /> : children}

    </Container>
  );
}

Index.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
};
